/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const WORKFLOW_2_3 = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": { areaName: "Area 1", },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [-179.9, -21.638510236780082],
                        [-64.75531982337898, -21.638510236780082],
                        [-64.75531982337898, -81.20502743784178],
                        [-179.9, -81.20502743784178],
                        [-179.9, -21.638510236780082]
                    ]
                ]
            },
        }
    ]
};

export default WORKFLOW_2_3